import ResultTemplates from './result-templates'

export default ResultTemplates;